<div
    class="flex justify-between items-start bg-white p-6 rounded-2xl border-[#E7EAF0] space-y-2 cursor-pointer shadow-elevation-1 hover:shadow-elevation-2 transition-shadow"
    [ngClass]="isNotification ? 'border-t rounded-none' : 'border'"
    [routerLink]="['/groups', groupSignal().id]">
    <div class="flex gap-3">
        <img class="w-12 h-12 rounded-lg" alt="GroupIcon" [src]="groupSignal().photo" />
        <div class="flex flex-col gap-2">
            <p class="text-[#0F172A] font-semibold text-sm">{{ groupSignal().name }}</p>
            <div class="flex items-center gap-4">
                <div class="flex items-center gap-1">
                    <img
                        alt="Privacy"
                        class="h-3 w-3"
                        [src]="
                            groupSignal().privacy === PrivacyTypeEnum.Public
                                ? '/assets/images/post/public-icon.svg'
                                : groupSignal().privacy === PrivacyTypeEnum.Private
                                  ? '/assets/images/post/anonymous-icon.svg'
                                  : '/assets/images/post/friends-icon.svg'
                        " />
                    <p class="text-[#475569] text-xs">{{ getPrivacyTypeLabel(groupSignal().privacy) }}</p>
                </div>
                <p class="text-[#475569] text-xs">{{ groupSignal().members.total }} members</p>
                @if (groupSignal().role) {
                    <div
                        class="w-fit bg-white border flex space-x-1 text-[#0A0A0A] text-[0.875rem] rounded-full py-1 px-2 capitalize">
                        {{ getGroupRoleTypeLabel(groupSignal().role) }}
                    </div>
                }
            </div>
            @if (groupSignal().cats && groupSignal().cats.length !== 0) {
                <div class="flex flex-wrap gap-2">
                    @for (tag of groupSignal().cats.slice(0, 2); track tag.id) {
                        <div
                            class="px-3 py-1 rounded-full bg-white border border-[#e7eaf0] text-[#0a0a0a] text-[0.8rem] font-medium transition duration-150">
                            {{ tag.name }}
                        </div>
                    }
                    @if (groupSignal().cats.length > 2) {
                        <div
                            class="px-3 py-1 rounded-full bg-white border border-[#e7eaf0] text-[#0a0a0a] text-[0.8rem] font-medium transition duration-150">
                            +{{ groupSignal().cats.length - 2 }}
                        </div>
                    }
                </div>
            }
        </div>
    </div>

    @if (isNotification) {
        <div class="flex gap-2 w-full lg:w-auto">
            <button
                type="button"
                class="border-button text-sm p-2 px-3 gap-2 flex items-center w-full lg:w-auto whitespace-nowrap"
                (click)="$event.stopPropagation(); acceptGroupInvite(groupSignal())">
                <img class="w-4 h-4" alt="Approve" src="/assets/images/shared/white-tick-icon.svg" />
                <p>Accept</p>
            </button>
            <button
                type="button"
                class="white-border-button text-sm p-2 px-3 gap-2 flex items-center text-[#D4183D] border border-[#D4183D] w-full lg:w-auto whitespace-nowrap"
                (click)="$event.stopPropagation(); declineGroupInvite(groupSignal())">
                <img class="w-4 h-4" alt="Reject" src="/assets/images/shared/cross-red-icon.svg" />
                <p>Decline</p>
            </button>
        </div>
    } @else if (groupSignal().privacy === PrivacyTypeEnum.Public) {
        @if (!groupSignal().joined) {
            <button
                type="button"
                class="border-button p-2 px-3 flex items-center"
                (click)="$event.stopPropagation(); joinGroup(groupSignal())">
                <p>Join</p>
            </button>
        }
    } @else if (groupSignal().privacy === PrivacyTypeEnum.Private) {
        @if (!groupSignal().joined) {
            <button
                type="button"
                class="p-2 px-3 flex items-center"
                [ngClass]="groupSignal().requested ? 'white-border-button text-[#4F66FF]' : 'border-button'"
                (click)="groupSignal().requested ? null : $event.stopPropagation(); joinPrivateGroup(groupSignal())">
                <p>{{ groupSignal().requested ? 'Requested' : 'Request to Join' }}</p>
            </button>
        }
    }

    @if (isEditPin) {
        <img
            class="w-3 h-auto"
            alt="Pin"
            [src]="
                groupSignal().pinned
                    ? '/assets/images/shared/pin-blue-icon.svg'
                    : '/assets/images/shared/pin-grey-inactive-icon.svg'
            "
            (click)="$event.stopPropagation(); togglePinGroup(groupSignal())" />
    }
</div>
